// Couche d'AFFICHAGE / workflow du statut DEVIS OMV, PAR-DESSUS l'enum StatutDevis
// backend (NON modifié — pilote TEF : DocuSign/signature/ANAH). COSMÉTIQUE : la valeur
// stockée n'est pas altérée. Le mapping enum↔clé workflow vit ICI (code) ; les LABELS
// et l'ORDRE viennent de la liste éditable statuts_devis (metier_config_listes).
//
// Clés workflow (ordre) :
//   brouillon ← devis.statut draft/brouillon
//   valide    ← devis.statut "emis"            (bouton "Valider")
//   envoye    ← devis.email_envoi.status==="sent" (envoi réussi)
//   signe     ← devis.statut devis_signe/signe  OU devis.statut_omv="signe"
//   en_cours / a_facturer / facture ← devis.statut_omv (manuel post-envoi)
//   paye      ← devis.statut "paye" OU devis.statut_omv="paye"

// Ordre + libellés par défaut (repli si la liste config n'est pas chargée).
export const DEVIS_STATUT_DEFAULTS = [
  { id: "brouillon", label: "Brouillon" },
  { id: "valide", label: "Validé" },
  { id: "envoye", label: "Envoyé" },
  { id: "signe", label: "Signé" },
  { id: "en_cours", label: "En cours (travaux)" },
  { id: "a_facturer", label: "À facturer" },
  { id: "facture", label: "Facturé" },
  { id: "paye", label: "Payé" },
];

// Statuts MANUELS post-envoi (sélecteur sur le devis). En auto = Validé/Envoyé.
export const DEVIS_STATUTS_MANUELS = ["signe", "en_cours", "a_facturer", "facture", "paye"];

// =============================================================================
// ÉDITABILITÉ DEVIS — miroir front de backend models.STATUTS_DEVIS_VERROUILLES
// =============================================================================
// Règle métier (JJ 2026-06-30) : un devis-objet est verrouillé UNIQUEMENT une
// fois SIGNÉ (devis_signe/signe). Avant signature — draft, emis (OMV), envoyé,
// etc. — il reste MODIFIABLE. Pour reprendre un signé → créer un nouveau devis.
// Cycle signature = exclusivement installateur (OMV/Climat) ; TEF n'a pas de
// devis-objet signé (vérifié en base). Miroir de backend
// models.STATUTS_DEVIS_VERROUILLES.
// ⚠️ SOURCE UNIQUE côté front : tout gating "peut modifier ce devis ?" passe
// par estModifiableDevis() — ne pas re-coder de test `statut === "draft"`.
export const STATUTS_DEVIS_VERROUILLES = new Set([
  "devis_signe", "signe",
]);

// True si le devis (ou son statut brut) peut être modifié.
export function estModifiableDevis(devisOrStatut) {
  const statut = typeof devisOrStatut === "string"
    ? devisOrStatut
    : (devisOrStatut && devisOrStatut.statut);
  if (!statut) return false;
  return !STATUTS_DEVIS_VERROUILLES.has(statut);
}

// Clé workflow OMV d'un devis (null si non géré → l'appelant garde son libellé).
export function devisStatutKey(devis) {
  if (!devis) return null;
  const m = devis.statut_omv;            // override manuel post-envoi (prioritaire)
  if (m) return m;
  if (devis.email_envoi && devis.email_envoi.status === "sent") return "envoye";
  const s = devis.statut;
  if (s === "emis") return "valide";
  if (s === "devis_signe" || s === "signe") return "signe";
  if (s === "paye") return "paye";
  if (s === "draft" || s === "brouillon") return "brouillon";
  return null;
}

// Libellé d'affichage : clé → label depuis la liste éditable (statutsList), sinon
// défaut, sinon le fallback fourni par l'appelant (TEF/Climat/statuts non gérés).
export function devisStatutLabel(devis, statutsList, fallbackLabel) {
  const key = devisStatutKey(devis);
  if (!key) return fallbackLabel;
  const list = Array.isArray(statutsList) ? statutsList : [];
  const item = list.find((i) => (i.id || i.value) === key)
    || DEVIS_STATUT_DEFAULTS.find((i) => i.id === key);
  return (item && item.label) || fallbackLabel || key;
}

// Compat Phase 1 : ancien appel à 2 args (devis, fallback) reste valide via la liste
// par défaut. (devisStatutLabel gère déjà statutsList absent.)
